[
  {
    "id": "GET-B8P-L302-001",
    "module": "Getalbegrip",
    "difficulty": 302,
    "question": "Los op: 3x + 5 = 20. Wat is x?",
    "options": [
      "5",
      "4",
      "6",
      "15"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "algebra",
    "familyId": "GET-ALGEBRA",
    "explanation": "Haal eerst 5 eraf: 3x = 15. Deel dan door 3: x = 5.",
    "distractorExplanations": {
      "1": "3x4+5=17.",
      "2": "3x6+5=23.",
      "3": "Je hebt de 5 niet afgetrokken."
    }
  },
  {
    "id": "GET-B8P-L302-002",
    "module": "Getalbegrip",
    "difficulty": 302,
    "question": "Wat is de wortel van 144?",
    "options": [
      "12",
      "14",
      "11",
      "72"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "worteltrekken",
    "familyId": "GET-WORTEL",
    "explanation": "12 $\\times$ 12 = 144.",
    "distractorExplanations": {
      "1": "14 x 14 = 196.",
      "2": "11 x 11 = 121.",
      "3": "Dat is de helft."
    }
  },
  {
    "id": "GET-B8P-L302-003",
    "module": "Getalbegrip",
    "difficulty": 302,
    "question": "Reken uit: $2^3$ + $3^2$ =",
    "options": [
      "17",
      "12",
      "18",
      "36"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "machten",
    "familyId": "GET-MACHTEN",
    "explanation": "$2^3$ = 2x2x2 = 8. $3^2$ = 3x3 = 9. 8 + 9 = 17.",
    "distractorExplanations": {
      "1": "Je hebt 2x3 en 3x2 gedaan.",
      "2": "Je hebt 8 en 9 vermenigvuldigd.",
      "3": "Je hebt de grondgetallen en exponenten opgeteld."
    }
  },
  {
    "id": "GET-B8P-L302-004",
    "module": "Getalbegrip",
    "difficulty": 302,
    "question": "Welk getal is GEEN priemgetal?",
    "options": [
      "9",
      "7",
      "11",
      "13"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "priemgetallen",
    "familyId": "GET-PRIEMGETALLEN",
    "explanation": "9 kun je delen door 1, 3 en 9. Priemgetallen hebben maar 2 delers.",
    "distractorExplanations": {
      "1": "7 is een priemgetal.",
      "2": "11 is een priemgetal.",
      "3": "13 is een priemgetal."
    }
  },
  {
    "id": "GET-B8P-L302-005",
    "module": "Getalbegrip",
    "difficulty": 302,
    "question": "Bereken de nieuwe prijs: € 200 + 10% - 10%",
    "options": [
      "€ 198",
      "€ 200",
      "€ 202",
      "€ 190"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten_volgorde",
    "familyId": "GET-PROC-VOLGORDE",
    "explanation": "200 + 10% (20) = 220. 10% van 220 is 22. 220 - 22 = 198.",
    "distractorExplanations": {
      "1": "Je dacht dat het gelijk bleef, maar de basis verandert.",
      "2": "Rekenfout.",
      "3": "Je hebt 10 euro eraf gehaald."
    }
  }
]